export enum NumericType {
    Currency = 0,
    Number = 1,
    Percent = 2,
    Time = 3,
}

export enum TimeType {
    None = 0,
    Second = 1,
    Minute = 2,
    Hour = 3,
    Time = 4
}

export default interface Metric {
    MetricID: number;

    Abbreviation: string;
    DefaultDirection: number;
    MetricDescription: string;
    MetricGroup: string;
    MetricName: string;
    MetricCustomName: string,
    MetricType: number;
    NumericType: NumericType;
    PointMetricType: number;
    TimeType: TimeType;
    hasPO: boolean;
    Formula?: string;
}

export enum DefaultDirection {
    Down = 0,
    Up = 1
}
